import { RESULTS_PER_PAGE } from "./constants";

const getPageCount = (itemsPerPage: number, itemsCount: number): number =>
  Math.ceil(itemsCount / itemsPerPage);

export const getTotalPages = (totalProducts = 0) => getPageCount(RESULTS_PER_PAGE, totalProducts);
